exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vote[data-v-51ab9176]{max-width:600px}.table-progress[data-v-51ab9176]{width:95%;font-size:12px;display:-ms-flexbox;display:flex}.table-progress .info-text[data-v-51ab9176]{padding-left:5px}.table-progress .count[data-v-51ab9176]{padding-left:10px;min-width:40px;display:inline-block;text-align:right}.input-static-text[data-v-51ab9176]{min-width:300px}", ""]);

// exports
